/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Pomodoro Technique breaks work into focused 25-minute sessions separated by short breaks. Press Start for a 25-minute focus session; the alarm tells you when to take a break.`)
};

const es_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Técnica Pomodoro divide el trabajo en sesiones enfocadas de 25 minutos separadas por descansos cortos. Presiona Iniciar para una sesión de enfoque de 25 minutos; la alarma te avisa cuándo tomar un descanso.`)
};

const de_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Pomodoro-Technik teilt Arbeit in fokussierte 25-Minuten-Sessions mit kurzen Pausen dazwischen. Drücke Start für eine 25-minütige Fokus-Session; der Alarm sagt dir, wann Pause ist.`)
};

const nl_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Pomodoro-techniek verdeelt werk in geconcentreerde sessies van 25 minuten, afgewisseld met korte pauzes. Druk op Start voor een focussessie van 25 minuten; het alarm laat je weten wanneer je pauze moet nemen.`)
};

const fr_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La technique Pomodoro divise le travail en sessions de concentration de 25 minutes séparées par de courtes pauses. Appuyez sur Démarrer pour une session de concentration de 25 minutes ; l’alarme vous indique quand faire une pause.`)
};

const it_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tecnica del Pomodoro suddivide il lavoro in sessioni concentrate di 25 minuti separate da brevi pause. Premi Avvia per una sessione di concentrazione di 25 minuti; l'allarme ti avvisa quando fare una pausa.`)
};

const pt_br2_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Técnica Pomodoro divide o trabalho em sessões focadas de 25 minutos separadas por pausas curtas. Pressione Iniciar para uma sessão de foco de 25 minutos; o alarme avisa quando é hora da pausa.`)
};

const pt_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Técnica Pomodoro divide o trabalho em sessões focadas de 25 minutos, separadas por pausas curtas. Prima Iniciar para uma sessão de foco de 25 minutos; o alarme avisa quando é hora de fazer uma pausa.`)
};

const ja_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポモドーロ・テクニックは、作業を25分の集中セッションと短い休憩に分ける手法です。スタートを押すと25分の集中セッションが始まり、アラームが休憩のタイミングを知らせます。`)
};

const zh_timer_pomodoro_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`番茄工作法将工作拆分为25分钟的专注时段，中间穿插短暂休息。点击开始进入25分钟专注时段；闹铃会提醒你何时该休息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_intro", locale)
	if (locale === "en") return en_timer_pomodoro_intro(inputs)
	if (locale === "es") return es_timer_pomodoro_intro(inputs)
	if (locale === "de") return de_timer_pomodoro_intro(inputs)
	if (locale === "nl") return nl_timer_pomodoro_intro(inputs)
	if (locale === "fr") return fr_timer_pomodoro_intro(inputs)
	if (locale === "it") return it_timer_pomodoro_intro(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_intro(inputs)
	if (locale === "pt") return pt_timer_pomodoro_intro(inputs)
	if (locale === "ja") return ja_timer_pomodoro_intro(inputs)
	return zh_timer_pomodoro_intro(inputs)
};